import { render, staticRenderFns } from "./AddCreditCard.vue?vue&type=template&id=3180a3a5&"
import script from "./AddCreditCard.vue?vue&type=script&lang=js&"
export * from "./AddCreditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports